export enum StoreID {
  NY = 1,
  LA,
  MIA,
  TYO,
}

export const STORE_DETAILS = {
  [StoreID.NY]: {
    name: 'ny',
    url: 'new-york',
  },
  [StoreID.LA]: {
    name: 'la',
    url: 'los-angeles',
  },
  [StoreID.MIA]: {
    name: 'mia',
    url: 'miami',
  },
  [StoreID.TYO]: {
    name: 'tyo',
    url: 'tokyo',
  },
}

const STORE_NAME = {
  [StoreID.NY]: 'FCNY',
  [StoreID.LA]: 'FCLA',
  [StoreID.MIA]: 'FC Miami',
  [StoreID.TYO]: 'FC Tokyo',
}

export const STORE_BY_URL = {
  ['new-york']: StoreID.NY,
  ['los-angeles']: StoreID.LA,
  ['miami']: StoreID.MIA,
  ['tokyo']: StoreID.TYO,
}

export const getStoreImageUrl = (storeID: number, isMobile: boolean) => {
  const imageUrl = `/static/staticPages/store-${STORE_DETAILS[storeID].name}`

  if (isMobile && storeID !== StoreID.LA) return imageUrl + '-mobile.png'

  return imageUrl + '.png'
}

export const getStoreNameByCity = (city: string) => {
  switch (city.toLowerCase()) {
    case 'new york':
      return STORE_NAME[StoreID.NY]
    case 'los angeles':
      return STORE_NAME[StoreID.LA]
    case 'miami':
      return STORE_NAME[StoreID.MIA]
    case 'tokyo':
      return STORE_NAME[StoreID.TYO]
    default:
      return city
  }
}
